import React, { FC, useRef } from 'react';
import Screenshot from '../../../../../../clients/sidebar/components/screenshots';
import useScreenshotView from 'appJS/hooks/useScreenshotView';
import { DashboardTask } from './queries';
import {
  DashboardProjectAccess,
  DashboardProjectContext
} from './projectContextQueries';

type Props = {
  task: DashboardTask;
  bugherdUrl: string;
  container: HTMLElement;
  currentUserId: string;
  currentUserRole: string;
  projectContext: DashboardProjectContext | null;
  accessTo: DashboardProjectAccess | null;
  updateTask: (attributes: Record<string, unknown>) => void;
};

export const DrawerScreenshot: FC<Props> = ({
  task,
  bugherdUrl,
  container,
  currentUserId,
  currentUserRole,
  projectContext,
  accessTo,
  updateTask
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const hasSelector = !!(task.selectorInfo as { path?: string })?.path;
  const { handleScreenshotToggle, handleRegenerateScreenshot, isCroppedView } =
    useScreenshotView({
      userId: Number(currentUserId),
      projectId: Number(task.project.id),
      organizationId: Number(task.project.organizationId),
      hasSelector,
      onRegenerateScreenshot: () =>
        updateTask({ retryScreenshotAt: new Date().toISOString() })
    });

  if (!accessTo || !projectContext) return null;

  return (
    <Screenshot
      screenshotData={{
        url: task.screenshotUrl || '',
        coordinates: task.data?.coordinates,
        screenshotKey: task.screenshotKey || '',
        screenshotError: task.screenshotErrors
      }}
      priorityId={Number(task.priorityId || 0)}
      orgId={Number(task.project.organizationId)}
      createdAt={task.createdAt}
      projectId={Number(task.project.id)}
      basicAuthUrl=""
      taskId={Number(task.id)}
      currentUser={{ id: Number(currentUserId), role: currentUserRole }}
      url={bugherdUrl}
      mobileScreenshots={accessTo.taskMobileScreenshot}
      setScreenshot={(screenshotUrl: string) => updateTask({ screenshotUrl })}
      container={container}
      isAdminView
      gotoTask={() => {}}
      taskUrls={{ relativeUrl: task.url || '' }}
      noSelector={!hasSelector}
      videoRef={videoRef}
      handleScreenshotToggle={handleScreenshotToggle}
      isCroppedView={isCroppedView}
      owner={{
        id: Number(projectContext.owner?.id || 0),
        name: projectContext.owner?.name || '',
        email: projectContext.owner?.email || ''
      }}
      billingRights={accessTo.billing}
      handleRegenerateScreenshot={handleRegenerateScreenshot}
      apiDomain={bugherdUrl}
      screenshotServerUrl={projectContext.screenshotServerUrl}
      retryScreenshotAt={task.retryScreenshotAt || ''}
    />
  );
};
